import React from 'react';
import { Formik, Form, Field, ErrorMessage } from 'formik';
import { Button, TextField, Typography } from '@mui/material';

import './RecoverPasswordForm.scss';

function RecoverPasswordForm({ onSubmit }) {

  function validate(values) {
    const errors = {};
  
    if (!values.email) {
      errors.email = 'Email inválido';
    }

    if (!values.code) {
      errors.code = 'Código de acesso inválido';
    }

    if (!values.password) {
      errors.password = 'Confirmação da senha inválida';
    }
  
    return errors;
  }

  return (
    <Formik
      initialValues={{
        email: '',
        code: '',
        password: ''
      }}
      validate={validate}
      onSubmit={onSubmit}
    >
      {({ isSubmitting }) => (
        <Form className="form">
          <Typography variant="h5" component="h1">
            Crie uma nova senha
          </Typography>
          <Field
            as={TextField}
            className="field"
            type="email"
            name="email"
            label="Email"
            variant="outlined"
            fullWidth
          />
          <ErrorMessage name="email" component="div" />
          <Field
            as={TextField}
            className="field"
            type="password"
            name="code"
            label="Código de acesso"
            variant="outlined"
            fullWidth
          />
          <ErrorMessage name="code" component="div" />
          <Field
            as={TextField}
            className="field"
            type="password"
            name="password"
            label="Nova senha"
            variant="outlined"
            fullWidth
          />
          <ErrorMessage name="password" component="div" />
          <Button
            type="submit"
            variant="contained"
            color="primary"
            className="button"
            disabled={isSubmitting}
            fullWidth
          >
            {isSubmitting ? 'Enviando ...' : 'Criar nova senha'}
          </Button>
          <Typography variant="p" component="p" className="instructions">
            Insira o código enviado para o seu email e cadastre uma nova senha
          </Typography>
        </Form>
      )}
    </Formik>
  );
}

export default RecoverPasswordForm;